import { reducer } from "./useStepsReducer";
import { useReducer, useCallback } from "react";

import { UPDATE_MULTIPLE_VALUES_ACTION } from "./useStepsReducer";

export const defaultState = {
  firstStep: {},
  secondStep: {},
  thirdStep: {},
  forthStep: {},
  fifthStep: {},
  sixthStep: {},
  sevenStep: {},
  eightStep: {},
  nineStep: {},
  type: "add",
  user_id: "",
  evaluation_id: "",
  submission_id: "",
  la_id: ""
};

export const useSteps = () => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  const updateMultipleValues = useCallback((data) => {
    dispatch({ type: UPDATE_MULTIPLE_VALUES_ACTION, payload: data });
  }, []);

  return {
    ...state,
    updateMultipleValues,
  };
};
